module.exports = __webpack_public_path__ + "69a6db9b202126598923d4fbab0757be.svg";